"use strict"

import { csvFormatRows } from "d3-dsv"

import {
  getActionLayers,
  getColumnHeaders,
  getRowData,
} from "../../../components/graphing/data_export/ObservationExporter"

export function exportCSVFromArray(data) {
  return csvFormatRows(data)
}

export function exportCommentsObject(
  actions,
  timeExtractor,
  minTime,
  maxTime,
  observationTypes = {},
  tzString,
  intl,
  multi = false,
) {
  const filteredLayers = getActionLayers(actions, timeExtractor, [], multi, intl)
  const [rows, additionalKeys] = getColumnHeaders(
    filteredLayers,
    observationTypes,
    timeExtractor.name,
    false,
    false,
    intl,
  )
  return getRowData(filteredLayers, rows, additionalKeys, timeExtractor, minTime, maxTime, false, tzString)
}
